import { render, staticRenderFns } from "./ModalDetailGroup.vue?vue&type=template&id=9f5dcd8a"
import script from "./ModalDetailGroup.vue?vue&type=script&lang=js"
export * from "./ModalDetailGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports